<template lang="pug">
md-table-card.card
  stitch-loader(:loading='loading', :size='45')

  div(v-if='hasUsersToDisplay')
    div.titleLine.styleRow
      p.rowElements
      p.rowElements Name
      p.rowElements Email
      p.rowElements Roles
      p.rowElements
    div.styleRow.colorHover(v-for='user in users', :key='user.user_id')
      div.rowElements
        md-avatar(class='md-medium')
          img(:src='user.picture')
      div.rowElements {{ user.user_metadata.name }}
      div.rowElements.overflow {{ user.email }}
      div.rowElements.overflow {{ fixForRoles(user) }}
      div.rowElements.iconsContainer.overflow
        md-button.md-icon-button.md-raised.btn(@click='editUser(user.user_id)')
          md-icon.icon(md-iconset="fa fa-pencil-alt")
        md-button.md-icon-button.md-raised.btn(@click='deleteUser(user.name, user.nickname ,user.user_id, fixForRoles(user))', :disabled='(isAdmin() || isAccountAdmin()) && user.app_metadata.authorization.roles.includes("Admin") || user.user_id === siteuser.user_id')
          md-icon.icon(md-iconset="fa fa-trash-alt")


    md-table-pagination(
      :md-size='currentPagination.size',
      :md-page='currentPagination.page',
      :md-total='totalUsers',
      md-label='Users',
      md-separator='of',
      :md-page-options='[10, 50]',
      @pagination='onPageChanged'
    )
  md-layout#no-results(v-if='hasNoResults' md-align='center')
    md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
    | No items to show
</template>

<script>

  import { mapState } from 'vuex';
  import userService from '../../services/userService';
  import stitchLoader from '../../shared-components/Loader';

  export default {
    components: {
      stitchLoader
    },
    data() {
      return {
        users: [],
        totalUsers: null,
        loading: false,
        currentPagination: {
          page: 1,
          size: 50
        },
        sort: {
          name: 'lastUpdated',
          type: 'desc'
        },
        searchText: ''
      };
    },
    computed: {
      ...mapState({
        siteuser: state => state.user.siteuser
      }),

      searchParams() {
        const params = {
          per_page: this.currentPagination.size,
          page: this.currentPagination.page - 1
        };
        if (this.searchText) {
          Object.assign(params, { name: this.searchText });
        }
        return params;
      },
      hasUsersToDisplay() {
        return !this.loading && this.users.length > 0;
      },
      hasNoResults() {
        return !this.loading && this.users.length === 0;
      }
    },
    methods: {
      showAlertToast(text, icon){
        this.$swal({
              text: text,
              position: 'bottom-left',
              icon: icon,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
              }
            )
      },

      isAdmin() {
        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('Admin');
        }
        return false;
      },
      isAccountAdmin() {
        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('AccountAdmin');
        }
        return false;
      },
      onPageChanged(paginationParams) {
        this.currentPagination = paginationParams;
        this.search();
      },
      onSort(sortParams) {
        this.sort = sortParams;
        this.search();
      },
      search() {
        this.loading = true;
        userService.getList(this.searchParams)
          .then((response) => {
            this.users = response.data.users;
            this.totalUsers = response.data.total;
          })
          .catch((error) => {
            console.error('Error while retrieving the list of users', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
      editUser(userId) {
        this.$router.push({
          name: 'EditUser',
          params: {
            id: encodeURIComponent(userId)
          }
        });
      },
      deleteUser(userEmail ,userName, userId, roles) {
        this.$swal.fire({
          title: 'Delete user',
          html: `<p><strong>Name</strong>: ${userName}</p> <p><strong>Email</strong>: ${userEmail}</p> <p><strong>Rol</strong>: ${roles}</p>`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete',
          cancelButtonText:'No',
          }).then((res) => {
            if(res.isConfirmed) {
              this.loading = true;
              userService.delete(userId).then(() =>{this.search()});
              this.showAlertToast('User deleted successfully', 'success');
            }
          })
          .catch(() => {
            this.showAlertToast('User could not be deleted. Please, try again later', 'error');
            this.loading = false;
          })
      },
      fixForRoles(user) {
        if(Array.isArray(user.app_metadata.authorization.roles)) {
          return user.app_metadata.authorization.roles.join(',  ')
        } else {
          return user.app_metadata.authorization.roles;
        }
      }

    },

    mounted() {
      this.search();
    }
  };
</script>

<style lang="scss" scoped>
.card{
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}
  .filters {
    padding: 2px 20px;
  }
  .search-btn {
    margin-top: 16px;
  }
  .md-table {
    .md-sortable.md-sorted, .md-sortable:hover {
      color: #0198cf;
    }
  }
  #no-results {
    margin: auto;
    padding: 20px;
    .md-icon {
      margin-right: 5px;
    }
  }

  .titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}
.colorHover:hover{
  background-color: #eee;
}

.iconsContainer{
  display: flex;
  justify-content: center;
}

.overflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/user/UserTable.vue